module.exports = __webpack_public_path__ + "img/ukc.4a376a67.png";